/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum Gender {
    Male = 'Male',
    Female = 'Female',
    Divers = 'Divers'
  }

    export const GenderTranslocoMap: Record<Gender, string> = {
    [Gender.Male]: 'gender.male',
    [Gender.Female]: 'gender.female',
    [Gender.Divers]: 'gender.divers',
    };

    export const GenderOptions = [
  { value: Gender.Male, labelKey: 'gender.male' },
  { value: Gender.Female, labelKey: 'gender.female' },
  { value: Gender.Divers, labelKey: 'gender.divers' },
    ];

